// extracted by mini-css-extract-plugin
export default {"root":"PunchupEventSummaryTile_root__HECFx","title":"PunchupEventSummaryTile_title__6QIwR punchupTextEntityName","meta":"PunchupEventSummaryTile_meta__TDMXK punchupTextMeta"};